window.addEventListener('alpine:init', () => {
  function resourceListingLink(data = {}) {
    var { removeSectionWrapper } = Alpine.store('utilities');

    return {
      ...data,

      isLoadingResourceListingLink: false,

      onClick() {
        if (this.isLoadingResourceListingLink) return;

        dispatchEvent(new CustomEvent('resourcelistinglinkclickstart'));

        this.isLoadingResourceListingLink = true;

        var url = this.$el.href;

        var sectionUrl = new URL(url);

        sectionUrl.searchParams.set('section_id', this.sectionId);

        fetch(sectionUrl)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            dispatchEvent(new CustomEvent('resourcelistinglinkclicksuccess', {
              detail: {
                url,
                sectionHtml,
                scrollToEl: this.scrollToEl
              }
            }));
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            dispatchEvent(new CustomEvent('resourcelistinglinkclickend'));
            this.isLoadingResourceListingLink = false;
          });
      }
    };
  };

  Alpine.data('resourceListingLink', resourceListingLink);
});
